import { useCallback, useEffect, useState } from 'react';
import { config } from '../Constants';
import { summarizeStatus } from '../utils/siteStatus';

/**
 * Polls /api/v1/status once a minute and ticks a clock once a second so
 * "12 seconds ago" counts up between polls. `summary` is null until the
 * first response so callers can render nothing rather than a false alarm.
 */
export const useSiteStatus = ({ tick = true } = {}) => {
    const [status, setStatus] = useState(null);
    const [error, setError] = useState(false);
    const [now, setNow] = useState(() => Date.now());

    const load = useCallback(async () => {
        try {
            const response = await fetch(`${config.url}/api/v1/status`);
            if (!response.ok) {
                throw new Error(`HTTP ${response.status}`);
            }
            const body = await response.json();
            setStatus(body.data);
            setError(false);
        } catch (err) {
            console.error('Error fetching site status:', err);
            setError(true);
        }
    }, []);

    useEffect(() => {
        load();
        const refresh = setInterval(load, 60_000);
        const clock = tick ? setInterval(() => setNow(Date.now()), 1000) : null;
        return () => {
            clearInterval(refresh);
            if (clock) {
                clearInterval(clock);
            }
        };
    }, [load, tick]);

    const retailers = status?.retailers || [];
    const summary = status || error ? summarizeStatus(retailers, { now }) : null;
    return { status, retailers, error, now, summary };
};

export default useSiteStatus;
